var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 325.1 262.8",
    style: {
      enableBackground: "new 0 0 325.1 262.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2F2F2;}\n\t.st1{fill:none;stroke:#CFCFCF;stroke-width:1.9198;stroke-linecap:round;stroke-linejoin:round;}\n\t.st2{fill:#CFCFCF;}\n\t.st3{fill:#FFFFFF;stroke:#BABABA;stroke-width:2.2586;stroke-linecap:round;stroke-linejoin:round;}\n\t.st4{fill:#D2D2D2;}\n\t.st5{fill:none;stroke:#BABABA;stroke-width:2.2586;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M197,100.6c-18.9,0.1-38.1-0.8-56.1-5.8S107,80.5,92.6,69.5c-9.5-7.2-18.1-12.9-30.4-12 c-12,0.6-23.5,5.1-32.8,12.8c-15.6,13.7-13.3,39-7,56.8c9.4,26.8,38,45.4,62.3,57.5c28.1,14,58.9,22.2,89.8,26.9 c27.1,4.1,61.9,7.1,85.4-10.6c21.6-16.2,27.5-53.4,22.2-78.4c-1.3-7.4-5.2-14.1-11.1-18.8c-15.2-11.1-37.7-3.7-54.8-3.3 C210,100.4,203.5,100.6,197,100.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.8,13v9.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.9,17.8h9.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M289,206.6v9.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M284.2,211.4h9.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31.4,164.6c1.2,0,2.2-1,2.2-2.2s-1-2.2-2.2-2.2c-1.2,0-2.2,1-2.2,2.2C29.2,163.6,30.2,164.6,31.4,164.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M219.8,23c1.2,0,2.2-1,2.2-2.2s-1-2.2-2.2-2.2s-2.2,1-2.2,2.2S218.6,23,219.8,23z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M158.5,255.3c45.8,0,82.9-2.3,82.9-5.1s-37.1-5.1-82.9-5.1s-82.9,2.3-82.9,5.1S112.7,255.3,158.5,255.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M94.6,39.4H215c3,0,5.9,1.2,8,3.3s3.3,5,3.3,8v143.2c0,3-1.2,5.9-3.3,8s-5,3.3-8,3.3H79.2c-3,0-5.9-1.2-8-3.3 s-3.3-5-3.3-8V66.3L94.6,39.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M225.8,109.1H101.6v97.4h124.1v-97.4H225.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M67.9,66.3h21.9c1.3,0,2.5-0.5,3.4-1.4s1.4-2.1,1.4-3.4V39.4L67.9,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M225.2,78H102.4c-4.8,0-8.7,3.9-8.7,8.7V113c0,4.8,3.9,8.7,8.7,8.7h122.8c4.8,0,8.7-3.9,8.7-8.7V86.7 C233.8,81.9,229.9,78,225.2,78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M117.6,107.4c4.2,0,7.5-3.4,7.5-7.5c0-4.2-3.4-7.5-7.5-7.5c-4.2,0-7.5,3.4-7.5,7.5S113.4,107.4,117.6,107.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M141.3,107.4c4.2,0,7.5-3.4,7.5-7.5c0-4.2-3.4-7.5-7.5-7.5c-4.2,0-7.5,3.4-7.5,7.5S137.1,107.4,141.3,107.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M165,107.4c4.2,0,7.5-3.4,7.5-7.5c0-4.2-3.4-7.5-7.5-7.5c-4.2,0-7.5,3.4-7.5,7.5S160.8,107.4,165,107.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M225.2,126.3H102.4c-4.8,0-8.7,3.9-8.7,8.7v26.3c0,4.8,3.9,8.7,8.7,8.7h122.8c4.8,0,8.7-3.9,8.7-8.7V135 C233.8,130.2,229.9,126.3,225.2,126.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M117.6,155.7c4.2,0,7.5-3.4,7.5-7.5c0-4.2-3.4-7.5-7.5-7.5c-4.2,0-7.5,3.4-7.5,7.5 C110.1,152.4,113.4,155.7,117.6,155.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M141.3,155.7c4.2,0,7.5-3.4,7.5-7.5c0-4.2-3.4-7.5-7.5-7.5c-4.2,0-7.5,3.4-7.5,7.5 C133.8,152.4,137.1,155.7,141.3,155.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M165,155.7c4.2,0,7.5-3.4,7.5-7.5c0-4.2-3.4-7.5-7.5-7.5c-4.2,0-7.5,3.4-7.5,7.5 C157.5,152.4,160.8,155.7,165,155.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M225.2,174.6H102.4c-4.8,0-8.7,3.9-8.7,8.7v26.3c0,4.8,3.9,8.7,8.7,8.7h122.8c4.8,0,8.7-3.9,8.7-8.7v-26.3 C233.8,178.5,229.9,174.6,225.2,174.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M117.6,204c4.2,0,7.5-3.4,7.5-7.5c0-4.2-3.4-7.5-7.5-7.5c-4.2,0-7.5,3.4-7.5,7.5S113.4,204,117.6,204z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M141.3,204c4.2,0,7.5-3.4,7.5-7.5c0-4.2-3.4-7.5-7.5-7.5c-4.2,0-7.5,3.4-7.5,7.5S137.1,204,141.3,204z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M165,204c4.2,0,7.5-3.4,7.5-7.5c0-4.2-3.4-7.5-7.5-7.5c-4.2,0-7.5,3.4-7.5,7.5S160.8,204,165,204z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M236.3,133.1c25.9,0,46.8-21,46.8-46.8c0-25.9-21-46.8-46.8-46.8s-46.8,21-46.8,46.8S210.4,133.1,236.3,133.1z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M269.5,120.2l12.5,12.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M280.6,126.6l-3.9,4c-1.7,1.8-1.7,4.7,0.1,6.5l33.6,32.2c1.8,1.7,4.7,1.7,6.5-0.1l3.9-4 c1.7-1.8,1.7-4.7-0.1-6.5l-33.6-32.1C285.2,124.7,282.3,124.8,280.6,126.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.d3ff1087caa3ff03a7b7503ae42517db.svg";
export { ForwardRef as ReactComponent };